// Add this to your user-subscriptions.js service file
import { SEARCH_SUBSCRIPTION_BY_EMAIL } from "../api-services/ApiEndpoints";

export const getUserSubscriptionsByEmail = async (email) => {
    const url = `${process.env.REACT_APP_API_URL}${SEARCH_SUBSCRIPTION_BY_EMAIL.replace('{email}', email)}`;
    const token = localStorage.getItem('token');

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch user subscriptions: ${response.status}`);
    }

    return await response.json();
};